import posthog from "posthog-js";

const captureError = (error: unknown, options?: Record<string, unknown>) => {
    posthog.captureException(error, options);
};

type ChessMoveBugDetails = {
    fen: string;
    positionIndex: number;
    user: string;
    whitePlayer: string;
    blackPlayer: string;
    slug: string;
    description: string;
    url: string;
    piece: string;
    moveRating?: string;
};

const captureChessMoveBug = (props: ChessMoveBugDetails) =>
    posthog.capture("chess_move_bug", props);

export const TrackingService = { captureError, captureChessMoveBug };
